import { createAction, props } from '@ngrx/store';

import { ShareButtonClickEventType, ShareDialogOpenEventType } from './share.models';

import { WatchlistChangeInterface } from '../watchlist/watchlist.models';

export const shareButtonClicked = createAction(
  '[Tracking][BAU365] Share button clicked',
  props<ShareButtonClickEventType>()
);
export const shareDialogOpened = createAction(
  '[Tracking][BAU365] Share dialog opened',
  props<ShareDialogOpenEventType>()
);
export const watchlistShareDialogOpened = createAction(
  '[Tracking][BAU365] Watchlist share dialog opened',
  props<WatchlistChangeInterface>()
);
export const watchlistShareButtonClicked = createAction(
  '[Tracking][BAU365] Watchlist share button clicked',
  props<{ change: WatchlistChangeInterface; network: string }>()
);
